import { getLevelNImagePathWithAPIKey } from "../../../services/b2b-frameworks-apiService";
import { showNotification } from "../../b2b-common/Notification";
import { useQuery } from "@tanstack/react-query";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";
import { useLoginContext } from "../../../App";

const useLevelNImagePathWithAPIKey = (frameworkSuite, frameworkId, levelId, locale = null, imageLabel = null) => {
    const { setNotification } = useLoginContext();
    const { t } = useB2BTranslation('b2b-frameworks', locale);

    const fetchImagePath = async (frameworkSuite, frameworkId, levelId, locale, imageLabel) => {
        try {
            const imagePath = await getLevelNImagePathWithAPIKey(frameworkSuite, frameworkId, levelId, locale, imageLabel);
            return imagePath;
        } catch (error) {
            console.error('Error fetching levelN image path:', error);
            showNotification(setNotification, t('Error fetching levelN image path: ') + error.message, 'error', 5000);
        }
    };

    const { data: imagePath } = useQuery({
        queryKey: ['imagePath', frameworkSuite, frameworkId, levelId, locale, imageLabel],
        queryFn: () => fetchImagePath(frameworkSuite, frameworkId, levelId, locale, imageLabel),
    });

    return imagePath;
};

export default useLevelNImagePathWithAPIKey;